import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import LocalisedMessage from 'components/Common/LocalisedMessage';

export const QuestionCheckBoxField = ({ intl, blockId, question, className, onChange }) => {
  const [inputValue, setInputValue] = useState(question?.answer ?? question.default ?? '');
  const [isInputFocused, setIsInputFocused] = useState(false);

  const onInputChange = () => {
    const newValue = inputValue === 'true' ? '' : 'true';
    setInputValue(newValue);
    onChange(question, newValue);
    return true;
  };

  useEffect(() => {
    if (inputValue) {
      onChange(question, inputValue);
    }
  }, []);

  return (<div className="single-inline-checkbox">
    <label className="form-checkbox">
      <input
        key={ `${ blockId }-${ question.id }` }
        id={ `${ blockId }-${ question.id }` }
        name={ question.id }
        className={ `${ className }${ !question.isValid ? ' error' : '' }` }
        type="checkbox"
        value="true"
        checked={ inputValue === 'true' }
        disabled={ question.disabled }
        onFocus={ () => setIsInputFocused(true) }
        onBlur={ () => setIsInputFocused(false) }
        onChange={ () => onInputChange() }
        aria-checked={ inputValue === 'true' }
        aria-describedby={ question.isValid === false ? (`${ blockId }-${ question.id }-error`) : undefined }
      /><i className={ `form-icon ${ isInputFocused ? 'focus' : '' }` } /><span><LocalisedMessage id={ question.componentProps?.option } /></span>
    </label>
  </div>);
};

QuestionCheckBoxField.displayName = 'QuestionCheckBoxField';

QuestionCheckBoxField.propTypes = {
  intl: PropTypes.shape().isRequired,
  blockId: PropTypes.string.isRequired,
  question: PropTypes.shape().isRequired,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

QuestionCheckBoxField.defaultProps = {
  className: '',
};

export default QuestionCheckBoxField;
